import { AppTemplateEntityModel } from "src/store/models/entity/appTemplate/entity";
import { AppTemplateHelperModel } from "src/store/models/entity/appTemplate/helper";
import { AppTemplateListModel } from "src/store/models/entity/appTemplate/list";

export const encooAppTemplateModels = {
  entity: AppTemplateEntityModel,
  list: AppTemplateListModel,
  helper: AppTemplateHelperModel,
};
